import React, { useContext } from 'react'
import classnames from 'classnames'

import { IProps } from '.'
import { CTATheme, Icon, renderIconSVG } from '../../utils'
import { Text } from '../Text'
import CTALinkOverridePropsContext from 'marketing-site/src/components/context/CTALinkOverridePropsContext'

export const CTALinkPlaceholder = (props: IProps): React.ReactElement => {
  const overrideProps = useContext(CTALinkOverridePropsContext)
  const {
    text: label,
    arrow = true,
    bgColor,
    small,
    wide,
    textSize,
  } = { ...props, ...overrideProps }

  const CTAThemeNames: Record<CTATheme, string> = {
    [CTATheme.BlackFill]: 'black-fill',
    [CTATheme.BlackOutline]: 'black-outline',
    [CTATheme.WhiteOutline]: 'white-outline',
    [CTATheme.LinkOnlyBlack]: 'link-only-black',
    [CTATheme.LinkOnlyWhite]: 'link-only-white',
    [CTATheme.TealFill]: 'teal-fill',
    [CTATheme.BlackFillTransparentHover]: 'black-fill-transparent-hover',
    [CTATheme.BlueFill]: 'blue-fill',
    [CTATheme.BlueOutline]: 'blue-outline',
    [CTATheme.LinkOnlyBlue]: 'link-only-blue',
  }

  const ctaLabelClasses = classnames(`cta-link cta-link--${CTAThemeNames[bgColor]}`, {
    'cta-link--small': small,
    'cta-link--wide': wide,
  })

  return (
    <div className={ctaLabelClasses}>
      <Text brand="default" size={textSize || 'button-bold'}>
        {label}
      </Text>
      {arrow && renderIconSVG(Icon.Arrow, 'cta-link__arrow')}
    </div>
  )
}

export default CTALinkPlaceholder
